import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import GenerateHomePageLinks from "../HomePageLinks/HomePageLinks";
import { MASTER_JOB_LABELS } from "../config/masterJobsApi";
import { HOME_CATEGORY_SUMMARIES, OG_IMAGE_URL } from "../config/publicPageContent";
import { SyllabusHomeSection } from "../Syllabus/SyllabusPages";
import "./home.css";

const homeHighlights = [
  "Daily updates for government jobs, admit cards, results, answer keys, and admission notices",
  "Topic-wise quiz practice and syllabus pages to support exam preparation",
  "Simple category-wise browsing so students can find important links faster",
];
const homeStudySteps = [
  "Use the search box to find the exam, post, board, or update you need.",
  "Open the full post and verify dates, eligibility, and instructions carefully.",
  "Visit the syllabus and quiz sections regularly to support preparation, not just application tracking.",
];

function AppHome() {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <Helmet>
        <title>AAMSchool - Free Govt Jobs, Admit Card, Results and Quiz Practice</title>
        <link rel="canonical" href="https://www.aamschool.in/" />
        <meta
          name="description"
          content="AAMSchool is a free platform for government job updates, admit cards, results, syllabus pages, and quiz practice."
        />
        <meta property="og:title" content="AAMSchool - Free Govt Jobs, Admit Card, Results and Quiz Practice" />
        <meta property="og:description" content="AAMSchool is a free platform for government job updates, admit cards, results, syllabus pages, and quiz practice." />
        <meta property="og:image" content={OG_IMAGE_URL} />
        <meta property="og:url" content="https://www.aamschool.in/" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="body-container">
        <div className="quiz-home-link-row">
          <Link className="quiz-home-link" to="/daily-current-affairs-quiz">
            Daily Current Affairs Quiz
            <span className="blink-new-badge">NEW</span>
          </Link>
        </div>

        <div className="search-container">
          <input
            type="text"
            placeholder="Search jobs, admit card, result..."
            className="global-search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="home-free-note">
          All major sections on AAMSchool are free to use for students, aspirants, and job seekers.
        </div>

        <GenerateHomePageLinks
          header="Latest Jobs"
          label={MASTER_JOB_LABELS.latestJobs}
          searchTerm={searchTerm}
          showFaq={false}
          viewMorePath="/latest-jobs"
        />
        <GenerateHomePageLinks
          header="Admit Cards"
          label={MASTER_JOB_LABELS.admitCards}
          searchTerm={searchTerm}
          showFaq={false}
          viewMorePath="/admit-card"
        />
        <GenerateHomePageLinks
          header="Latest Results"
          label={MASTER_JOB_LABELS.latestResults}
          searchTerm={searchTerm}
          showFaq={false}
          viewMorePath="/results"
        />
        <GenerateHomePageLinks
          header="Admission"
          label={MASTER_JOB_LABELS.admission}
          searchTerm={searchTerm}
          showFaq={false}
          viewMorePath="/admission"
        />
        <GenerateHomePageLinks
          header="Answer Keys"
          label={MASTER_JOB_LABELS.answerKeys}
          searchTerm={searchTerm}
          showFaq={false}
          viewMorePath="/answer-key"
        />
        <SyllabusHomeSection searchTerm={searchTerm} />

        <section className="home-content-shell" aria-label="Homepage overview">
          <div className="home-content-card home-content-card-wide">
            <h2>Why Students Use AAMSchool</h2>
            <p>
              AAMSchool is built to help students and job seekers track important education and
              recruitment updates in one place. Along with the latest notifications, the site also
              supports preparation through syllabus pages and quiz practice so users can move from
              browsing updates to active study.
            </p>
          </div>
          <div className="home-content-card">
            <h2>What You Can Find Here</h2>
            <ul className="home-content-list">
              {homeHighlights.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="home-content-card">
            <h2>Best Way To Use The Site</h2>
            <ul className="home-content-list">
              {homeStudySteps.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="home-hero-card" aria-label="AAMSchool homepage introduction">
          <h1>AAMSchool: Government Jobs, Results, Admit Cards and Exam Preparation</h1>
          <p className="home-hero-copy">
            AAMSchool organizes public recruitment and education updates into category pages that
            are easier to scan. Students can discover notices, open the full post, and then verify
            every important detail from the official source before applying or preparing.
          </p>
          <div className="home-category-grid">
            {HOME_CATEGORY_SUMMARIES.map((item) => (
              <article key={item.href} className="home-category-card">
                <h2>
                  <Link to={item.href}>{item.title}</Link>
                </h2>
                <p>{item.summary}</p>
              </article>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export default AppHome;


